import React from 'react';
import { LoaderCircle } from 'lucide-react';

type PageLoaderProps = {
  title?: string;
  description?: string;
};

export function PageLoader({
  title = 'Cargando',
  description = 'Estamos preparando esta vista para ti.',
}: PageLoaderProps) {
  return (
    <div className="flex min-h-[40vh] items-center justify-center px-4 py-10">
      <div className="w-full max-w-md rounded-[28px] border border-slate-200/80 bg-white/90 p-8 text-center shadow-[0_20px_60px_-40px_rgba(15,23,42,0.45)] backdrop-blur">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-600">
          <LoaderCircle className="h-7 w-7 animate-spin" />
        </div>
        <h2 className="mt-5 text-xl font-semibold text-slate-900">{title}</h2>
        <p className="mt-2 text-sm leading-6 text-slate-500">{description}</p>
      </div>
    </div>
  );
}
